import React, { Suspense } from 'react';
import ReactDOM from 'react-dom/client';
import { BrowserRouter } from "react-router-dom"
import './index.css';
import App from './App';
import "bootstrap/dist/css/bootstrap.css";
import { Provider } from 'react-redux';
import store from "./app/services/store";
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import { SignalRProvider } from "./app/services/SignalRContext";
import { LoaderProvider } from "./app/services/LoaderContext";
import { I18nextProvider } from 'react-i18next';
import i18n from './i18n';
import { LocalizationProvider } from "@mui/x-date-pickers";
import { AdapterDayjs } from "@mui/x-date-pickers/AdapterDayjs";

dayjs.extend(utc);
dayjs.extend(timezone);
// As of React 18
const root = ReactDOM.createRoot(document.getElementById('root'));

root.render(
  <I18nextProvider i18n={i18n}>
    <Suspense fallback={null}>
      <LocalizationProvider dateAdapter={AdapterDayjs}>
        <LoaderProvider>
          <SignalRProvider>
            <BrowserRouter>
              <Provider store={store}>
                <App />
              </Provider>
            </BrowserRouter>
          </SignalRProvider>
        </LoaderProvider>
      </LocalizationProvider>
    </Suspense>
  </I18nextProvider>
);
